import { Checkbox, Container, Divider, FormControlLabel, Grid, IconButton, TextField, Tooltip } from '@material-ui/core'
import React, { useEffect } from 'react'
import FlexView from 'react-flexview/lib'
import { useForm } from 'react-hook-form'
import adminApi from '../../api/admin.api'
import { EventEmitterService, EventKey } from '../../services/EventEmitterService'
import { awaitWithLoading } from '../../services/utils'
import NewFillButton from '../Core/NewFillButton'
import { ReactComponent as CompanyLogoSvg } from '../../assets/company-logo.svg';
import { ReactComponent as CameraIconSvg } from '../../assets/camera_add.svg';
import { ReactComponent as CameraChangeSvg } from '../../assets/change-photo.svg';
import './CreatePartnershipForm.scss'
import { EMAIL_REGEX } from '../../Constants'
import { ElevatedCircle } from '../Core/ElevatedCircle'
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import { useHistory } from 'react-router-dom'
import { AdminContextStore } from './AdminContext'

export const CreatePartnershipForm = () => {
    const history = useHistory()
    const adminContext = React.useContext(AdminContextStore)
    const {register, errors, getValues, setValue, watch, triggerValidation} = useForm({mode: 'onChange'})
    const [img, setImg] = React.useState("")
    const [favicon, setFavicon] = React.useState("")
    const profilePicture = React.useRef(null) 
    const faviconPicture = React.useRef(null) 
    const [isBroker, setIsBroker] = React.useState(false)


    const onProfilePictureSelected = async (event) => {
        setImg(URL.createObjectURL(event.target.files[0]))
        setValue('logo', event.target.files[0])
    }

    const onFaviconSelected = async (event) => {
        setFavicon(URL.createObjectURL(event.target.files[0]))
        setValue('favicon', event.target.files[0])
    }

    const uploadProfilePicture = () => profilePicture.current.click()
    const uploadFavicon = () => faviconPicture.current.click()

    const submit = async () => {
        let valid = await triggerValidation()
        
        if(!valid) return

        var form = getValues()
        form.redeem_code = getValues()['affiliation_code']
        form.partnership_code = getValues()['theme_key']
        let res = await awaitWithLoading(adminApi.createAgency(form)) 
        if(res.ok) {
            EventEmitterService.dispatch(EventKey.ShowSuccess, 
                {title: "Agency Created!",
                body: "A new agency has been created, you can now add agents to that agency",
                onClose: () => {
                    history.push('/broker/admin/agencies')
                    awaitWithLoading(adminContext.loadAgencies())}
                })
        }
        else 
            EventEmitterService.dispatch(EventKey.ShowError, res)
    }

    React.useEffect(() => {
        register('logo', {required: true})
        register('favicon', {required: true})
    }, [register])

    return (<Container className='margin-top-basic'>
        <div className="text-promotion black bold">Create New Partnership</div> 

        <br />

        <br />
        <div className="text-title blue bold">Agency Details</div> 
        <Divider />
        <br />
        
        <FlexView>
            <div>
                <div className="company-logo-container-2 margin-right-basic clickable" onClick={uploadProfilePicture}>
                    {!img ? 
                        <React.Fragment>
                            <CompanyLogoSvg />
                            <div className="company-logo-text-2 gray bold text-body">Company Logo</div>
                        </React.Fragment>
                    : <img className="company-logo-img" src={img}/>}
                    {/* </SkyElementHoverPopover> */}
                    <input type='file' accept="image/*" id='file' onChange={onProfilePictureSelected} ref={profilePicture} style={{display: 'none'}}/>
                    <div className="camera-box clickable" >
                        {!img ? <CameraIconSvg /> : <CameraChangeSvg />}
                    </div>
                </div>
                {!!errors.logo && <div className="text-body textcenter red">required</div>}
                <br />
                <ElevatedCircle>
                    {!favicon && <Tooltip title={"Favicon"} placement="top">
                            <IconButton onClick={uploadFavicon}>
                            <AddAPhotoIcon />
                        </IconButton>
                    </Tooltip>}
                    {favicon && <img onClick={uploadFavicon} className="clickable favicon-logo-img" src={favicon}/>}
                </ElevatedCircle>
                <input type='file' accept="image/*" id='file' onChange={onFaviconSelected} ref={faviconPicture} style={{display: 'none'}}/>
                {!!errors.favicon && <div className="text-body margin-top-small textcenter red">favicon required</div>}
            </div>
        
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12}> 
                <FormControlLabel
                    className="margin-bottom-small"
                    name="is_broker"
                    control={
                        <Checkbox
                        checked={isBroker}
                        inputRef={register({required: false})}
                        name="is_broker"
                        color="primary"
                        onChange={() => {
                            setIsBroker(!isBroker);
                        }}
                        />
                    }
                    label="This partnership is also a broker"
                    />
                </Grid>
                <Grid item xs={12} sm={4}> 
                    <TextField inputRef={register({required: true})} name="partnership_name" label={"Agency Name"} error={!!errors.partnership_name} helperText={!!errors.partnership_name ? 'required' : 'Agency\'s name to identify'} fullWidth variant="outlined" />
                </Grid>
                <Grid item xs={12} sm={4}> 
                    <TextField inputRef={register({required: true})} name="affiliation_code" label={"Affiliation Code"} error={!!errors.affiliation_code} helperText={!!errors.affiliation_code ? 'required' : 'for example: VOOOM2021, AJG2020'} fullWidth variant="outlined" />
                </Grid>
                <Grid item xs={12} sm={4}> 
                    <TextField inputRef={register({required: true})} name="description" label={"Description"} error={!!errors.description} helperText={!!errors.description ? 'required' : 'for example: Gallagher Drone Insurance powered by SkyWatch.AI'} fullWidth variant="outlined" />
                </Grid>
                <Grid item xs={12} sm={4}> 
                    <TextField name="contact_email" label={"Contact Email"} error={!!errors.contact_email} fullWidth variant="outlined" type="email" inputRef={register({required: true, pattern: { value: EMAIL_REGEX, message: "Invalid email address"} })}  helperText={!!errors.contact_email && (errors.contact_email.message || errors.contact_email.type)}/>
                </Grid>
            </Grid>
        </FlexView>
        <br />
        <div className="text-title blue bold">Agency Theme</div> 
        <Divider />
        <br />
        <Grid container spacing={3}>
            <Grid item xs={12} sm={4}> 
                <TextField inputRef={register({required: true})} name="theme_key" label={"Theme Key"} error={!!errors.theme_key} helperText={!!errors.theme_key ? 'required' : 'Will be used as the domain prefix'} fullWidth variant="outlined" />
            </Grid>
            <Grid item xs={12} sm={4}> 
                <TextField inputRef={register({required: true, validate: k => k.startsWith('#'), minLength: 7, maxLength: 7 })} name="theme_blue" label={"Blue"} error={!!errors.theme_blue} helperText={!!errors.theme_blue ? ((errors.theme_blue.type == 'required' && 'required') || ((errors.theme_blue.type == 'validate' || errors.theme_blue.type == 'minLength' || errors.theme_blue.type == 'maxLength') && 'Must start with # and have 6 english letters')) : 'Theme main color, for example: #abbcas'} fullWidth variant="outlined" />
            </Grid>
        </Grid>
        <FlexView hAlignContent='left'>
            <NewFillButton onClick={submit} flat green>Submit</NewFillButton>
        </FlexView>

    </Container>)
}